<template>
  <div class="wrapper box  box_v">
    <!--头部-->
    <page-head title="健康信息" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn">
    </page-head>

    <div class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
        <div class="box">
          <div class="box_f1">
            <i-form ref="formInline" inline label-position="top">
              <row :gutter="80">
                <i-col span="8">
                  <FormItem label="姓名" prop="userName">
                    <Input v-model="userName" placeholder="请输入姓名" clearable @on-enter="initFangyiList" @on-clear="initFangyiList"/>
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="联系电话" prop="phoneNO">
                    <Input v-model="phoneNO" placeholder="请输入联系电话" clearable @on-enter="initFangyiList"  @on-clear="initFangyiList"/>
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="是否有发热等症状" prop="symptomSelf">
                    <Select v-model="fever"  @on-change="initFangyiList">
                      <Option :value="1" :key="1">是</Option>
                      <Option :value="2" :key="2">否</Option>
                    </Select>
                  </FormItem>
                </i-col>
              </row>
              <row :gutter="80">
                <i-col span="8">
                  <FormItem label="日期" prop="time">
                    <DatePicker v-model="time" type="daterange" format="yyyy-MM-dd" placeholder="请选择"
                    clearable @on-change="initFangyiList"></DatePicker>
                  </FormItem>
                </i-col>
                <i-col span="8" v-if="isJiedao">
                  <select-community ref="community" @communityChange="communityChange"></select-community>
                </i-col>
                <i-col span="8">
                  <FormItem label="所属小区" prop="host">
                    <Select v-model="zoneId" class="input" clearable @on-change="initFangyiList">
                      <Option v-for="item in zoneList" :value="item.zoneId" :key="item.zoneId">{{ item.zoneName }}</Option>
                    </Select>
                  </FormItem>
                </i-col>
              </row>
            </i-form>
          </div>
        </div>
      </Card>
      <Card dis-hover :padding="0" class="box_f1" style="margin-top: 20px">
        <div class="table-card">
          <div>
            <Button class="bkcc-btn del-btn" @click="delFangyi">删除</Button>
          </div>
          <Table border :columns="settingColumn" :data="fangyiList" :loading="isTableLoading"
                 @on-selection-change="selectTableItem" @on-row-dblclick="clickRow"></Table>
          <page :total="total" @on-change="pageChange" class="page" :page-size="rows" :current="page" show-total/>
        </div>
      </Card>
    </div>
    <Modal title="确认" v-model="delModal" @on-cancel="cancelModal" @on-ok="delPeopleHealthy">
      <div>确认删除记录吗？删除后将无法恢复</div>
    </Modal>
  </div>
</template>

<script>
  import pageHead from '../../../components/head'
  import selectCommunity from '../../../components/selectCommunity'

  var that
  export default {
    name: 'healthRecord',
    components: {
      pageHead,
      selectCommunity
    },
    data() {
      return {
        page: 1,
        rows: 10,
        userName: '',
        phoneNO: '',
        zoneId: '',
        zoneList: [],
        isLoadZoneList: false,
        time:'',
        fever:'',
        //1--咳嗽,2--感冒,4--发烧,8--乏力,16--呼吸困难,32--腹泻,64--其他,0--以上均无
        areadata: [],//行政区域
        fangyiList: [],
        btnList: [
          {
            name: '搜索',
            type: 'search',
            loading: false,
          }, {
            name: '重置',
            type: 'init',
            loading: false,
            btnType: 'default',
          }, {
            name: '导出',
            type: 'export',
            loading: false,
            btnType: 'default',
          }
        ],
        settingColumn: [{
            type: 'selection',
            width: 70,
            align: 'center',
            fixed: 'left'
          }, 
          {
            title: "姓名",
            width: '95',
            resizable: true,
            key: "name",
            fixed: 'left'
          },
          {
            title: "身份证号",
            key: 'idCardNO',
            resizable: true,
            width:'200',
          },
          {
            title: "联系电话",
            key: "phoneNO",
            resizable: true,
             width:'150',
          },{
            title: "行政区域",
            key: "communityName",
            resizable: true,
            width:'180',
          },{
            title: "是否出现发热、乏力、干咳、逐渐出现呼吸困难症",
            width:'150',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    {
                      style: {
                        color: that.fangyiList[params.index].fever == 1 ? '#ff7b44' : '#a1a1a1',
                      },
                      on: {
                        click: () => {
                          that.changeStatus(params.index)
                        }
                      }
                    },
                    that.fangyiList[params.index].fever == 1 ? '是' : '否'
                  )
                ]);
            }
          },
          {
            title: "体温",
            width:'150',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    that.fangyiList[params.index].temperature?(parseFloat(that.fangyiList[params.index].temperature)/100).toFixed(1)+'℃':''
                  )
                ]);
            }
          },
          {
            title: "备注",
            width:'150',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    that.fangyiList[params.index].remark ? that.fangyiList[params.index].remark : '无'
                  )
                ]);
            }
          },
          {
            title: "提交人",
            width:'150',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    that.fangyiList[params.index].sgName ? that.fangyiList[params.index].sgName : '本人提交'
                  )
                ]);
            }
          },
          {
            title: "提交时间",
            key: "recordTime",
            width:'150',
          },
          {
            title: "操作",
             width: 240,
            fixed: 'right',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.gotoDetail(params.index)
                        }
                      }
                    },
                    "[详情]"
                  ),
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                        marginLeft: "10px",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.delItem(params.index)
                        }
                      }
                    },
                    "[删除]"
                  )
                ]);
            }
          }],
        total: 0,
        isTableLoading: false,
        selectAppointment: [],
        communityId: 0,
        childShequ: [],
        delId:'',
        delModal:false,
        //级联行政区域
        communityIdList:[]
      }
    },
    computed: {
      isJiedao() {
        return parseInt(this.$store.state.isJiedao);
      }
    },
    watch: {
      communityId(newVal) {
        //点击重置的时候 communityId变为0，此时不应获取当前社区下的微社区
        //watch 只针对当前为街道，才会发生communityId变化
        this.zoneList = [];
        this.zoneId = ''
        if (newVal != 0) {
          this.getZoneList(newVal)
        } 
        
        
        this.initFangyiList()
      },
      '$route' (to, from) {
        if(from.name == "addFangyi")  this.getFangyiList()
      }
    },
    methods: {
      communityChange(value){
        console.log(value)
        this.communityId = value.communityId
        this.communityIdList = value.childrenIdList
        this.initFangyiList()
      },
      gotoDetail (index) {
        var id = this.fangyiList[index].epdemicPeopleId,
          communityId = this.fangyiList[index].communityId
        this.$router.push({
          name: 'fangyidetail',
          query: {id, communityId}
        })
      },
      //获取行政区域
      getArea(item, callback) {
        item.loading = true;
        this.$post(this.urlobj.getArea + 'id=' + item.id).then(res => {
          let data = res.map(_item => {
            let resturn_data = {
              pid: _item.pid,
              id: _item.id,
              value: _item.text,
              label: _item.text,
              level: item.level + 1,
            }
            if (item.level != 2) {
              resturn_data.children = []
              resturn_data.loading = false
            }

            return resturn_data
          })
          if (item.level == 0) {
            this.areadata = data
          } else {
            item.loading = false;
            item.children = data
            callback()

          }

        }).catch(e => {
          this.$Message.error('获取行政区域失败')
        })
      },


      initFangyiList() {
        this.page = 1
        this.getFangyiList()
      },
      getFangyiList() {
        let {page, rows, userName, phoneNO, fever, phone, time, communityIdList, zoneId} = this
       console.log('=============getFangyiList==========')
       console.log(communityIdList)
        this.isTableLoading = true
        let beginTime = "";
        let endTime = ""
        if (time[0])  {
          beginTime = this.$util.FormatDate(new Date(time[0]),'yyyy-MM-dd')
          endTime = this.$util.FormatDate(new Date(time[1]),'yyyy-MM-dd')
        }
        let data = {
          pageNum: page,
          pageSize: rows,
          userName,
          phoneNO,
          fever,
          beginTime,
          endTime,
          communityIdList: communityIdList.length?communityIdList.join(','):'',
          zoneId,
        }

        // if (backTime) data.backTime = this.$util.FormatDate(backTime, "yyyy-MM-dd");
        // console.log(data)

        this.$get(this.urlobj.getHealthyList, data).then(res => {
          this.isTableLoading = false
          //if (!orderField && !orderSeq && !eventTypeId && !eventNameId && !res.total) this.isNoData = true
          this.total = res.total
          this.fangyiList = res.rows
          this.fangyiList.forEach(item=>{
            item.recordTime = this.$util.FormatDate(new Date(item.createTime),'MM-dd') + (parseInt(this.$util.FormatDate(new Date(item.createTime),'HH'))>12?' 下午':' 上午')
          })

        })
      },
      export() {
        let {userName, phoneNO, fever, phone, time, communityId, zoneId} = this
        let beginTime = "";
        let endTime = ""
        if (time[0])  {
          beginTime = this.$util.FormatDate(new Date(time[0]),'yyyy-MM-dd')
          endTime = this.$util.FormatDate(new Date(time[1]),'yyyy-MM-dd')
        }

        if(userName === undefined) userName = ""
        if(phoneNO === undefined) phoneNO = ""
        if(fever === undefined) fever = ""
        if(phone === undefined) phone = ""
        if(communityId === undefined) communityId = ""
        if(zoneId === undefined) zoneId = ""

        let url = this.urlobj.exportHealthList + '?communityId=' + communityId + '&zoneId=' + zoneId
            + '&userName=' + userName + '&phoneNO=' + phoneNO + '&fever=' + fever
            + '&beginTime=' + beginTime + '&endTime=' + endTime
            + '&token=' + this.$store.state.access_token 
        window.open(url)
      },
      handleBtn(type) {
        if (type == 'export') {
          this.export()
        } else if (type == 'search') {
          this.initFangyiList()
        } else if (type == 'init') {
          this.userName = ''
          this.phoneNO = ''
          this.fever = ''
          this.time = ''
          this.communityId = 0
          this.zoneId = ''
          this.communityIdList = []
          this.$store.state.isJiedao && (this.$refs.community.selectCommunity="");
          this.initFangyiList()
        }
      },
      getDetail(index) {
        this.$router.push({
          name: 'fangyidetail',
          query: {id: this.fangyiList[index].id, communityId: this.fangyiList[index].communityId}
        })
      },
      delItem(index) {
        this.delModal = true
        this.delId = this.fangyiList[index].id
        //this.delPeopleHealthy(this.fangyiList[index].id)
      },
      delFangyi() {
        var id = this.selectAppointment.map(item => item.id).join(',')
        if (!id) {
          this.$Message.warning('请选择要操作的记录')
          return
        }
        this.delModal = true
        this.delId = id
        //this.delPeopleHealthy(id)
      },
      delPeopleHealthy() {
        this.$delete(this.urlobj.delPeopleHealthy + '?idList=' + this.delId).then(res => {
          this.$Message.success('删除成功')
          this.page = 1
          this.getFangyiList()
        }).catch(e => {

        })
      },
      cancelModal(){

      },
      pageChange(val) {
        this.page = val;
        this.getFangyiList();
      },
      selectTableItem(value) {
        this.selectAppointment = value
        //this.selectAppointment = this._.unionBy(this.selectAppointment, value, 'id')
      },
      // cancelTableItem() {
      //   var value = arguments[1]
      //   var delIndex
      //   this.selectAppointment.forEach((item, index) => {
      //     if (item.id == value.id) delIndex = index
      //   })
      //   this.selectAppointment.splice(delIndex, 1)
      // },
      clickRow(value) {
        this.$router.push({
          name: 'fangyidetail',
          query: {
            id: value.epdemicPeopleId,
            communityId: value.communityId
          }
        })
      },
      getChildShequ() {
        var url = this.urlobj.getChildShequ;
        this.$get(url).then(res => {
          var item = {
            name: '全部',
            id: 0,
          }
          var list = res.rows.map(item => {
            return {
              name: item.communityName,
              id: item.communityId
            };
          });
          list.unshift(item)
          this.childShequ = list
        });
      },
      //获取微社区列表
      getZoneList(id) {
        this.isLoadZoneList = true
        let url = this.urlobj.zoneList
        this.$get(url, {
          communityId: id,
          zoneType:1,
          hasChild:1
        }).then(res => {
          this.isLoadZoneList = false
          this.zoneList = res.rows
          this.zoneList.push({
            zoneId:0,
            zoneName:'其他'
          })
        }).catch(e => {
          this.isLoadZoneList = false;
          console.log(e)
        })
      },
      //点击选择微社区列表时
      selectZone(val) {
        if (val) {
          //下拉框展开，且communityId为空
          if (!this.communityId) {
            this.$Message.info('请先选择社区')
          } else if (this.isLoadZoneList) {
            this.$Message.info('查询中,请稍后')
          }
        }
      },
    },
    created() {},
    mounted() {
      that = this
      this.getFangyiList()
      if (parseInt(this.$store.state.isJiedao)) {
        this.getChildShequ();
      } else {
        this.getZoneList(this.$store.state.streetorcommunityid)
      }

    }
  }
</script>

<style scoped lang="less">
  /deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }

  /deep/ .ivu-date-picker {
    display: block;
  }

  /deep/ .ivu-card-body {
    height: 100%;
  }

  /deep/ .ivu-table-tip {
    overflow-x: hidden;
  }

  .wrapper {
    height: 100%;
  }

  .add-btn {
    min-width: 60px;
    height: 28px;
    line-height: 13px;
    display: block;
  }

  .del-btn {
    margin-bottom: 20px;
  }

  .tab-wrapper {
    position: absolute;
    left: 20px;
    .tab-btn {
      height: 30px;
      line-height: 30px;
      width: 85px;
      text-align: center;
      background: #fff;
      color: #999;
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    .active {
      background: #ff7b44;
      color: #fff
    }
  }

  .nodata-card {
    margin: 0 20px 20px;
    align-items: center;
    justify-content: center;
    img {
      height: 280px;
      width: 390px;
    }
    .text {
      font-size: 15px;
      color: #ff7744;
      line-height: 1;
      padding: 25px 0 30px;
      letter-spacing: 10px;
      text-align: center;
    }
  }

  .card-box {
    margin: 0 20px 20px;
  }

  .table-card {
    padding: 20px 20px 80px;
    position: relative;
    height: 100%;
    text-align: right;
  }

  .page {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
  .note {
    font-size: 16px !important;
    margin-bottom: 20px;
    .download {
      color: #ff7b44;
      text-decoration: underline;
      margin-left: 5px;
    }
  }
</style>
